module.exports = __webpack_public_path__ + "img/129.d4ffcf0a.jpg";